import { createContext } from 'react';

const initialPromptContext: PromptContextStore = {
  prompt: '',
  isProcessed: false,
  setPrompt: () => {},
  setProcessed: () => {},
};

export const PromptContext = createContext<PromptContextStore>(initialPromptContext);
